import React from 'react';
import { Route, Link } from 'react-router-dom';
import { Row, Col, Table, Button } from 'react-bootstrap';
// src
import { ORDERS_SUMMARY_PATH, EDIT_ORDER, LANDING } from '../../routes/routes_production.js';
import { PostRequest } from '../../api/PostRequest.js';
import { FeedbackAlertBox } from '../Orders/Response/ResponseBox.js';
import { PDFGenerator } from './PDFGenerator.js';

/**
 * Genera il riepilogo dell'ordine in formato PDF
 * @param {*} e 
 */
function handlePrintPDF(e) {  
  let params = {
    "request": "getSingleOrder", 
    "booking": e.target.dataset.booking
  };   
  
  PostRequest(ORDERS_SUMMARY_PATH, params)
  .then((res) => PDFGenerator(res[0]))
  .catch((err) => console.log(err));    
}

/**
 * Tabella degli ordini
 */
class OrdersTable extends React.Component { 
  render() {          
    const {orders, page, rowsPerPage} = this.props;

    if(orders) {   
      
      // sottoinsieme degli ordini, basato sul numero di ordini visibili per pagina
      let start = rowsPerPage * (page-1);
      let end = rowsPerPage * page;
      let subOrders = orders.slice(start, end);    

      return(
        <Row className="noNegativeMargin">
        <Col xs={12}>
          <Table className="mt-2" responsive bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Nr. prenotazione</th>
              <th>Nr. serata</th>
              <th>Data serata</th>
              <th>Operatore</th>
              <th>Ultima modifica</th>
              <th colSpan="2">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {                
              Object.values(subOrders).map((order, index) => { 
                index = (index===null)? 0 : ++index;
                return (
                  <Route render={({history}) => (  
                    <OrdersTableRow 
                      nrPrenotazione={order['nrPrenotazione']} 
                      nrSerata={order['nrSerata']} 
                      dataSerata={order['dataSerata']} 
                      nomeUtente={order['nomeUtente']} 
                      inseritoIl={order['dataInsert'] +" "+ order['timeInsert']}
                      index={index} showRow={index<=rowsPerPage}            
                      handleEdit={() => {                                  
                          history.push({
                            pathname: ".."+EDIT_ORDER, 
                            state: {
                              booking: order['nrPrenotazione'],
                              viewOnly: !this.props.enableEdit,
                            }
                          })                                  
                        }                                
                      }       
                      handlePrintPDF={handlePrintPDF.bind(order['nrPrenotazione'])}  
                      enableEdit={this.props.enableEdit}                     
                    />                      
                  )} key={index}  />
                )
              })             
            }
          </tbody>
        </Table>
      </Col>
      </Row>
      );
    }

    return (
      <FeedbackAlertBox margin="mt-2" alertStyle="warning">        
        {(this.props.enableEdit)?
          <React.Fragment>
            <p>Non hai ancora inserito nessun ordine.</p>
            <Link to={".."+LANDING}>Nuovo ordine</Link>
            <br/> 
          </React.Fragment>
          :           
          <p>Non è ancora stato inserito nessun ordine oppure non sei un supervisore.</p>                       
        }
      </FeedbackAlertBox>
    )
  } 
}

const OrdersTableRow = (props) => (
  <tr className={props.showRow? "" : "hiddenTableRow"}>
    <td>{props.index}</td>
    <td>{props.nrPrenotazione}</td>    
    <td>{props.nrSerata}</td>    
    <td>{props.dataSerata}</td>    
    <td>{props.nomeUtente}</td>    
    <td>{props.inseritoIl}</td> 
    <td>
      <Button bsStyle="link" className="noSpaceButton"
              onClick={props.handleEdit}>
        {(props.enableEdit)? "Modifica" : "Visualizza"}
      </Button>      
    </td>           
    <td>
      <Button bsStyle="link" className="noSpaceButton"
              onClick={props.handlePrintPDF} 
              data-booking={props.nrPrenotazione}>PDF</Button>
    </td>
  </tr>
);

export default OrdersTable;


// WEBPACK FOOTER //
// ./src/cmp/Summary/OrdersTable.js